firebird.controller('chooseAudioOptionsCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    'logService',
    'avDeviceService',
    'storageService',
    'connectivityService',
    'analyticsWrapperService',
    function (
        $window,
        $rootScope,
        $scope,
        logService,
        avDeviceService,
        storageService,
        connectivityService,
        analyticsWrapperService
    ) {
        var self = this;
        const logger = logService.createLoggerWithSource('chooseAudioOptionsCtrl');

        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;
        self.sendUserChoice = sendUserChoice;
        self.connectWithAudioText = connectWithAudioText;

        self.modalState = 'closed';
        self.rememberAudioChoice = false;
        self.choices = { audio: 'audio', phone: 'phone', noAudio: 'no-audio' };

        $scope.$on('show-modal', self.onShowModal);
        $scope.$on('hide-modal', self.onHideModal);

        init();

        ////////////////////////

        function init() {
            logger.debug('chooseAudioOptionsCtrl - initialized');
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('chooseAudioOptions') !== -1) {
                self.modalState = 'closed';
            }

            digest();
        }

        function onShowModal(e, modalName) {
            if (modalName === 'chooseAudioOptions') {
                self.modalState = 'open';
                analyticsWrapperService.eventTrack('Meeting - choose your audio modal shown', {
                    category: 'Choose Audio Options'
                });
            }
        }

        function connectWithAudioText() {
            var withAudioSources = 'Computer audio',
                withoutAudioSources = 'Listen only on computer';

            return avDeviceService.hasMicrophone() ? withAudioSources : withoutAudioSources;
        }

        function sendUserChoice(data) {
            //TODO: This sets off a chain events that leads to "no audio"
            //being considered a "switched-to-phone" state, which is fine for most cases
            //but disrupts logic meant for users who are actually switched to phone...
            //
            //We'll need to clean this up in the long run
            logger.log('Choose Audio Options modal - clicked switch-to-phone');

            connectivityService.setInitialAudioChoice(data);

            self.onHideModal({}, 'chooseAudioOptions');
            $rootScope.$broadcast('new-user-audio-choice', data);

            if (self.rememberAudioChoice && data != self.choices.noAudio) {
                var usingPhone = data == self.choices.phone;
                storageService.set('using-phone-for-audio', usingPhone);
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
